import type { ReactNode } from 'react'

import { Collapse } from '@subaio/components'

import { Container } from './Container'
import { Icon } from './Icon'

type Props = {
	hasError: boolean
	errorMessage?: ReactNode
}

export const InputError = ({ hasError, errorMessage }: Props) => (
	<Collapse isOpen={hasError} fill>
		<Container isVisible={hasError}>
			{hasError && (
				<>
					<Icon />
					{errorMessage}
				</>
			)}
		</Container>
	</Collapse>
)
